import {v1_OrderType_select_column} from '../../generated/types';

const OrderType = {
    ...v1_OrderType_select_column,
    res: 'v1_OrderType',
    comp: {},
    rel: {},
};

export default OrderType;
